import { PaymentMethodResponseType } from '#/shared/api/generated/billing/models'

const ACTIVE_STATUS = 'active'

const CARD_GATEWAY_TYPES: readonly string[] = [
  PaymentMethodResponseType.stripe,
  PaymentMethodResponseType.authorize_net,
  PaymentMethodResponseType.firstdata,
  PaymentMethodResponseType.quickbooks,
  PaymentMethodResponseType.square,
  PaymentMethodResponseType.card,
]

/**
 * All the test needs, and all a list row carries — `/payment-methods` returns
 * the slim `PaymentMethodListItem`, the detail endpoint the full record.
 */
interface CardGatewayCandidate {
  status: string
  type: string
}

export function isActiveCardGatewayMethod(
  method: CardGatewayCandidate,
): boolean {
  return (
    method.status === ACTIVE_STATUS && CARD_GATEWAY_TYPES.includes(method.type)
  )
}

// QuickBooks Payments has no invoice concept — no hosted invoice and no
// "pay now" email — so the send-invoice actions only make sense on other
// gateways (Stripe emails the pay-now link).
export function gatewaySupportsInvoiceEmail(type: string | undefined): boolean {
  return type !== PaymentMethodResponseType.quickbooks
}
